import { type TableColumnSpec } from "#blocks/Table/buildTableColumns"

export const SEMESTER_TABLE_COLUMNS: TableColumnSpec[] = [
  { key: "name", width: 200 },
  { key: "startDate", width: 120 },
  { key: "endDate", width: 120 },
  { key: "lastUpdatedAt", width: 140, title: "Last Updated" },
]

export const SEMESTER_SORTABLE_FIELDS = ["name", "lastUpdatedAt"] as const
